module.exports = __webpack_public_path__ + "img/住院案件调解-调解信息@2x.fb034d98.png";